export const mapBBRDataToInputValue = (
	data: { id: string; label?: string; type: string; value: string },
	metaArea: MetaArea
): string => {
	const apiFieldListOfValuesMappingItems = metaArea.items[0].content.apiFieldListOfValuesMappings.items;

	const mappingForCurrentField = apiFieldListOfValuesMappingItems.find(
		(mappingItem) => mappingItem.content.fieldIdentifier.uid === data.id
	);

	const mappedData = mappingForCurrentField?.content.logicalNameMappings.find(
		(mapping) => mapping.value === data.value
	);

	return mappedData ? mappedData?.key : data?.value; // If there's a mapping, return the key, otherwise return the original value
};
